module.exports = __webpack_public_path__ + "static/media/Acrilico (39).885d7415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (39).jpg
// module id = 307
// module chunks = 0